import React, { useState } from "react";
import "../../styles/newsletter.css";

export const NewsLetterBox = () => {
    const [email, setEmail] = useState('');
    return (
        <div className="n-l-box">
            <div className="n-l-left">
                <div className="n-l-title">NEWSLETTER</div>
                <div className="n-l-caption">
                    Subscribe to the free newsletter to receive the latest
                    news 
                </div>
                <div className="sub-form-box">
                    <input
                        className="sub-form-input"
                        type="email"
                        name="email"
                        placeholder="Your e-mail address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <button
                        className="sub-form-button"
                    >
                        Subscribe
                    </button>
                </div>
            </div>
            <img className="sub-box-image" src="/images/newsletter_img.png" alt="" />
        </div>
    );
}